"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _Loader = _interopRequireDefault(require("@insided/shared/uikit/Loader"));

// eslint-disable-next-line import/no-internal-modules
var Attachment = function Attachment(_ref) {
  var filename = _ref.filename,
      url = _ref.url,
      key = _ref.key,
      onDelete = _ref.onDelete;
  return url ? (0, _preact.h)("li", {
    className: "content-attachments-list__item",
    key: key
  }, (0, _preact.h)("a", {
    className: "content-attachments-list__link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(url)
  }, filename), (0, _preact.h)(_Close.default, {
    width: 18,
    height: 18,
    class: "content-attachments__delete",
    onClick: onDelete
  })) : (0, _preact.h)("li", {
    className: "content-attachments-list__item",
    key: key
  }, (0, _preact.h)("span", {
    className: "content-attachments-list__text--loading"
  }, filename), (0, _preact.h)("span", {
    style: {
      width: '24px',
      position: 'relative'
    }
  }, (0, _preact.h)(_Loader.default, null)));
};

var _default = Attachment;
exports.default = _default;